import script from "./Captcha.vue?vue&type=script&setup=true&lang=js"
export * from "./Captcha.vue?vue&type=script&setup=true&lang=js"

import "./Captcha.vue?vue&type=style&index=0&id=5184ba27&lang=scss"

const __exports__ = script;

export default __exports__